import React from "react";
import InnerBanner from "views/Components/Comman/InnerBanner";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

import GoogleIcon from "assets/images/icons/google-icon.png";
import IosIcon from "assets/images/icons/ios-icon.png";

import Layout from "../Layout";

const Signup = () => {
  return (
    <Layout>
      <InnerBanner
        SmallTitle="Sign up"
        Title="A secure online <br /> meeting platform"
      />
      <section className="login-detail">
        <div className="white-box overlay-banner">
          <div className="buttons-auth">
            <Link to="/" className="btn outline-btn">
              <Image src={GoogleIcon} alt="Google" />
              Sign up with Google
            </Link>
            <Link to="/" className="btn outline-btn">
              <Image src={IosIcon} alt="Google" />
              Sign up with Apple
            </Link>
          </div>
        </div>
        <div className="login-signup-para">
        Already have an account? <Link to="/signin">Login</Link>
        </div>
      </section>
    </Layout>
  );
};

export default Signup;
